module.exports = __webpack_public_path__ + "img/default-img.ae758ce2.png";